import React from 'react';

type TestFabricJsonViewerProps = Readonly<{
  jsonData?: any;
}>;

export default function TestFabricJsonViewer({ jsonData }: TestFabricJsonViewerProps) {
  const copyToClipboard = () => {
    if (jsonData) {
      navigator.clipboard.writeText(JSON.stringify(jsonData, null, 2));
    }
  };

  return (
    <div className="filter-form">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3>JSON Response</h3>
        <button 
          onClick={copyToClipboard} 
          className="btn-secondary"
          disabled={!jsonData}
          style={{ padding: '8px 16px' }}
        >
          Copy JSON
        </button>
      </div>
      
      <div style={{
        backgroundColor: '#1e1e1e',
        color: '#d4d4d4',
        padding: '16px',
        borderRadius: '4px',
        maxHeight: '500px',
        overflowY: 'auto',
        fontFamily: 'Monaco, Menlo, "Courier New", monospace',
        fontSize: '13px',
        lineHeight: '1.5',
        border: '1px solid #3e3e3e'
      }}>
        {jsonData ? (
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {JSON.stringify(jsonData, null, 2)}
          </pre>
        ) : (
          <div style={{ color: '#888', fontStyle: 'italic' }}>
            No data to display. JSON responses will appear here.
          </div>
        )}
      </div>
    </div>
  );
}
